var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframe",attrs:{"id":_vm.value.id,"srcdoc":_vm.iframeHtml,"sandbox":"allow-same-origin allow-forms allow-popups allow-scripts allow-pointer-lock"}})}
var staticRenderFns = []

export { render, staticRenderFns }